module.exports = __webpack_public_path__ + "3afd9edb270e1264b62920e94df892da.png";